import { Text, Button } from 'iq-blueberry'
import Modal from 'components/common/Modal'
import './style.styl'
import OutlineClose from 'iq-blueberry/dist/reactIcons/OutlineClose'

const SimpleModal = ({ onCloseModal, isOpen, title, text, actionButton, textButton, children, customClass}) => {
  return(
    <div className={`bb-simple-modal ${customClass}`}>
      <Modal
        modalName="modal"
        onCloseModal={onCloseModal}
        openedModals={{ modal: { isOpen } }}
      >
        <div className='close-button' onClick={onCloseModal}>
          <OutlineClose />
        </div>
        <Text
          as="h1"
          variant="body-medium"
          className="app-modal__title"
        >
          {title}
        </Text>
        {text && <Text
          as="p"
          variant="body-medium"
          className="app-modal__text"
        >
          {text}
        </Text>}
        {children}
        <Button justify="center" expand="x" onClick={actionButton}>{textButton}</Button>
      </Modal>
    </div>
  )
}

export default SimpleModal
